export enum EVENTS_TABLE_COLUMNS {
    EVENT_DATE = 'EventDate',
    USERNAME = 'Username',
    DEVICE_ID = 'DeviceId',
    CATEGORY = 'Category',
    DESCRIPTION = 'Description',
    MESSAGE = 'Message',
}

export const EVENTS_DEFAULT_SORT_COLUMN = EVENTS_TABLE_COLUMNS.EVENT_DATE;
export const EVENTS_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const EVENTS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const EVENTS_PAGE_DEFAULT_SIZE = 10;
export const EVENTS_MAX_DAYS_BACK = 14;

export const EVENTS_TABLE_HEADER = [
    EVENTS_TABLE_COLUMNS.EVENT_DATE,
    EVENTS_TABLE_COLUMNS.USERNAME,
    EVENTS_TABLE_COLUMNS.DEVICE_ID,
    EVENTS_TABLE_COLUMNS.CATEGORY,
    EVENTS_TABLE_COLUMNS.DESCRIPTION,
    EVENTS_TABLE_COLUMNS.MESSAGE,
];

export const EVENT_COLUMNS = [
    { name: 'USERNAME', value: EVENTS_TABLE_COLUMNS.USERNAME },
    { name: 'DEVICE', value: EVENTS_TABLE_COLUMNS.DEVICE_ID },
    { name: 'TYPE', value: EVENTS_TABLE_COLUMNS.CATEGORY },
    { name: 'DESCRIPTION', value: EVENTS_TABLE_COLUMNS.DESCRIPTION }
];

export enum EEventIds {
    GatewayConfigured = 12,
    GatewayConfigured2 = 18,
    DeviceError = 22,
    DeviceOnline = 26,
    DeviceInput = 27,
    DeviceOutput = 28,
    DeviceConfigured = 16,
    ConnectedAutomationCreated = 43,
    ConnectedAutomationRemoved = 45,
    ConnectedAutomationScanReady = 46,
    ConnectedAutomationScanRunning = 47,
    PermissionCreated = 55,
    PermissionReady = 56,
    PermissionActive = 57,
    PermissionExpired = 58,
    DeviceRemoved = 31,
    TaskCreate = 81,
    TaskStarted = 82,
    TaskPending = 83,
    TaskRunning = 84,
    TaskAborting = 85,
    TaskAborted = 86,
    TaskError = 87,
    TaskDone = 88,
    DeviceFwUpdateStarted = 93,
    DeviceFwUpdateProgress = 94,
    DeviceFwUpdateFinished = 95,
    DeviceFwUpdateError = 96,
    DeviceBusyStateNotAvailable = 97,
    DeviceBusyStateAvailable = 98,
    OutputCommandError = 35
}
